<template>
  <v-dialog v-model="showVideo" persistent max-width="1000">
    <v-card>
      <div class="text-xs-right">
        <v-btn
          flat
          fab
          dark
          small
          color="grey"
          @click="$emit('input', false)"
          style="line-height: 10px"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </div>

      <v-tabs v-model="active" slider-color="primary">
        <v-tab :key="'facebook'" :href="'#facebook'" ripple>Facebook</v-tab>
        <v-tab :key="'url'" :href="'#url'" ripple>{{ $t('Link') }}</v-tab>
        <template v-if="selectedBot && ['summithr'].includes(selectedBot.type)">
          <v-tab :key="'uplaod'" :href="'#upload'" ripple>{{ $t('Upload') }}</v-tab>
        </template>
      </v-tabs>
      <v-card-text>
        <v-flex xs12 class="form-control pa-1">
          <div class="caption">Notify</div>
          <input
            type="text"
            placeholder="You receive message"
            v-model.lazy="notify"
            class="form-control"
            maxlength="255"
          />
        </v-flex>
        <div v-if="active == 'facebook'">
          <video-list @onSelect="addVideo"></video-list>
        </div>
        <div v-if="active == 'url'">
          <div class="flex-all-center">
            <video v-if="videourl" id="video-element" width="60%" controls crossorigin="anonymous">
              <source :src="videourl" type="video/mp4" />
            </video>
          </div>
          <div class="caption">{{ $t('Link') }}</div>
          <div class="form-control" :class="{ 'has-error': errors.has('videourl') }">
            <textarea
              style="min-height: 90px"
              :placeholder="$t('Link')"
              data-vv-name="videourl"
              :data-vv-as="$t('Link')"
              v-model="videourl"
              v-validate="
                active == 'url'
                  ? {
                      required: true,
                      regex: /(\.(mp4)$|^(https:\/\/drive\.google\.com\/uc))/,
                      isUrl: true
                    }
                  : ''
              "
            ></textarea>
            <span class="text-error" v-show="errors.has('videourl')">{{
              errors.first('videourl')
            }}</span>
          </div>

          <div class="text-xs-center">
            <v-btn :loading="loading" depressed color="primary" @click="addVideo">{{
              $t('Select')
            }}</v-btn>
          </div>
        </div>
        <div v-if="active == 'upload'">
          <UploadVideo2 @onUploaded="onUploaded" :pageid="selectedBot.pageid" />

          <div class="text-xs-center">
            <v-btn :loading="loading" depressed color="primary" @click="addVideo">{{
              $t('Select')
            }}</v-btn>
          </div>
        </div>

        <div class="mt-4 caption">
          {{
            $t(
              'Note: Large video files are slow to download , it can cause a failure and file type must be .mp4'
            )
          }}
        </div>
        <div class="caption">{{ $t('moreover recommend file size = 25MB') }}</div>
      </v-card-text>
      <div class="mt-5" style="display: none">
        <div id="preview"></div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import VideoList from './VideoList'
import api from '@/api'
import UploadVideo2 from '@/components/elements/UploadVideo2.vue'
export default {
  props: ['value'],
  data: function () {
    return {
      showVideo: this.value,
      loading: false,
      active: 'facebook',
      videourl: null,
      notify: null
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  components: {
    VideoList,
    UploadVideo2
  },
  methods: {
    onUploaded(videoUrl) {
      this.videourl = videoUrl
    },
    addVideo: async function (video) {
      var vm = this
      vm.loading = true
      var _VIDEO = document.querySelector('#video-element')
      if (_VIDEO && _VIDEO.videoWidth == 0 && _VIDEO.videoHeight == 0) {
        vm.loading = false
        return
      }
      vm.$validator.validate().then(async (result) => {
        if (!result) {
          // do stuff if not valid.

          vm.goToErrorInput()
          return false
        }
        var canvas = document.createElement('canvas')
        canvas.setAttribute('width', _VIDEO.videoWidth)
        canvas.setAttribute('height', _VIDEO.videoHeight)
        canvas.setAttribute('crossorigin', 'anonymous')
        var ctx = canvas.getContext('2d')
        ctx.drawImage(_VIDEO, 0, 0, _VIDEO.videoWidth, _VIDEO.videoHeight)
        document.getElementById('preview').appendChild(canvas)
        let img = canvas.toDataURL('image/png')
        let blobBin = atob(img.split(',')[1])

        var my_array = []
        for (var i = 0; i < blobBin.length; i++) {
          my_array.push(blobBin.charCodeAt(i))
        }
        var file = new Blob([new Uint8Array(my_array)], { type: 'image/png' })

        let url = await vm.upload(
          file,
          vm.videourl
            .split(/(\\|\/)/g)
            .pop()
            .split('.')[0]
        )
        vm.loading = false
        let w = _VIDEO.videoWidth
        let h = _VIDEO.videoHeight
        let r = h / w
        h = 1280 * r
        if (vm.active == 'facebook') {
          vm.$emit('onAddVideo', {
            source: 'https://www.facebook.com' + video.permalink_url,
            picture: video.picture,
            type: 'video',
            sourceline: video.source
          })
        } else if (['url', 'upload'].includes(vm.active)) {
          // vm.$emit('onAddVideo', {
          //   source: vm.videourl,
          //   picture: null,
          //   type: 'video',
          //   sourceline: vm.videourl
          // })
          let data = {
            type: 'imagemap',
            baseUrl: url + '?_ignored=',
            altText: vm.notify ? vm.notify : 'You receive message',
            is_rich_video: true,
            baseSize: {
              width: 1280,
              height: h
            },
            video: {
              originalContentUrl: vm.videourl,
              previewImageUrl: url + '?_ignored=',
              area: {
                x: 0,
                y: 0,
                width: 1280,
                height: h
              }
            },
            actions: [
              {
                type: 'uri',
                linkUri: 'https://www.google.com/',
                area: {
                  x: 0,
                  y: 0,
                  width: 1,
                  height: 1
                }
              }
            ]
          }
          vm.$emit('onAddVideo', data)
        }
      })
    },
    upload(file, name) {
      let data = {
        name: name + '.png',
        type: 'image/png',
        file: file
      }
      let vm = this
      return new Promise((resolve, reject) => {
        api.getSignedRequest(data, function (error, url) {
          if (error) {
            reject(error)
          }

          url = encodeURI(url)

          vm.currentImage = url
          vm.loading = false
          vm.$emit('input', vm.currentImage)
          if (vm.multiple) {
            vm.multiplefile.push(vm.currentImage)
            if (vm.filelength == vm.multiplefile.length) {
              vm.$emit('onUploaded', vm.multiplefile)
            }
          } else {
            vm.$emit('onUploaded', vm.currentImage)
          }
          resolve(url)
        })
      })
    }
  },
  watch: {
    value: function (newVal) {
      this.showVideo = newVal
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/ModalVideo.vue